// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2m-o2","col":"styles_col__3NWGX"};